/* Discount animation only. FK8 owns the permanent cart presentation and validated prices. */
(function () {
  'use strict';

  const script = document.currentScript;
  if (!script || window.__MSNO_QA_DISCOUNT_REVEAL__) return;
  window.__MSNO_QA_DISCOUNT_REVEAL__ = true;
  const stylesheet = script.getAttribute('data-qa-discount-reveal-css')
    || new URL('qa-discount-reveal.css', script.src).href;
  const controllers = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ownedSelector = '[data-qa-discount-reveal-owned]';

  function amount(value) {
    const match = String(value || '').match(/^(\d{1,15})(?:\.(\d{1,2}))?$/);
    return match ? BigInt(match[1]) * 100n + BigInt((match[2] || '').padEnd(2, '0')) : null;
  }

  function displayedAmount(value) {
    const match = String(value || '').replace(/\s/g, '').match(/^(\d{1,15})(?:,(\d{2}))?kr$/);
    return match ? BigInt(match[1]) * 100n + BigInt(match[2] || '0') : null;
  }

  function isOwned(node) {
    const element = node.nodeType === 1 ? node : node.parentElement;
    return Boolean(element && element.closest && element.closest(ownedSelector));
  }

  function relevantMutation(record) {
    if (isOwned(record.target)) return false;
    if (record.type !== 'childList') return true;
    return [...record.addedNodes, ...record.removedNodes].some(node => !isOwned(node));
  }

  function mount(root, scope) {
    let disabled = false;
    let queued = false;
    let cssReady = false;
    let total = null;
    let overlay = null;
    let visualLabel = null;
    let visualValue = null;
    let badge = null;
    let generation = 0;
    let activeQuoteKey = '';
    let lastSettledGoods = '';
    const timers = new Set();
    function reset() {
      generation += 1;
      timers.forEach(timer => window.clearTimeout(timer));
      timers.clear();
      activeQuoteKey = '';
      if (total) total.removeAttribute('data-qa-discount-reveal-phase');
      if (overlay) overlay.hidden = true;
      if (badge) badge.hidden = true;
    }

    function failOpen() {
      disabled = true;
      reset();
      if (overlay) overlay.remove();
      if (badge) badge.remove();
      observer.disconnect();
      hostObserver.disconnect();
    }

    function read() {
      const currentTotal = scope.querySelector('[data-aa-total]');
      const opened = root.getAttribute('data-aa-open') === 'true' && !root.hidden;
      if (!currentTotal || !opened || currentTotal.hidden) return null;
      const busy = currentTotal.getAttribute('aria-busy') === 'true';
      if (busy) return { total: currentTotal, busy: true };
      if (root.getAttribute('data-aa-state') !== 'ready'
        || root.hasAttribute('data-aa-line-intent')
        || scope.querySelector('[data-aa-line-dirty="true"], [data-aa-line-saving="true"]')) return null;

      const lines = scope.querySelector('[data-aa-lines]');
      const rows = lines && [...lines.children];
      if (!rows || !rows.length) return null;
      const goods = rows.map(row => {
        const quantity = row.querySelector('[data-aa-line-quantity]');
        const title = row.querySelector('.msno-aa-fk7-v2__line-title');
        const sku = row.querySelector('.msno-aa-fk7-v2__line-meta');
        if (!quantity || !title || !/^[1-9]\d{0,8}$/.test(quantity.value)) return null;
        // Line-key property hashes can change during checkout; SKU/title and
        // confirmed quantity do not make a mode switch a new shopping basket.
        return [sku ? sku.textContent : title.textContent, title.textContent, quantity.value];
      });
      if (goods.some(row => !row)) return null;
      const goodsKey = JSON.stringify(goods.map(row => JSON.stringify(row)).sort());
      const breakdown = scope.querySelector('[data-aa-breakdown]');
      if (!breakdown || breakdown.hidden) return null;
      const beforeRow = breakdown.querySelector('.msno-aa-fk7-v2__money-row--before-discount');
      const totalRow = breakdown.querySelector('.msno-aa-fk7-v2__money-row--total');
      const discountValue = breakdown.querySelector('.msno-aa-fk7-v2__discount-row strong');
      const totalValue = currentTotal.querySelector('[data-aa-total-value]');
      const final = totalRow && amount(totalRow.getAttribute('data-aa-amount'));
      if (final === null || !totalValue || displayedAmount(totalValue.textContent) !== final) return null;
      if (!beforeRow || !discountValue) return { total: currentTotal, goodsKey, discount: 0n };
      const before = amount(beforeRow.getAttribute('data-aa-amount'));
      const beforeValue = beforeRow.querySelector('strong');
      const savingText = discountValue.textContent.trim().replace(/^[-−]\s*/, '');
      const discount = displayedAmount(savingText);
      if (before === null || discount === null || discount <= 0n || before - discount !== final
        || !beforeValue || displayedAmount(beforeValue.textContent) !== before) return null;
      return {
        total: currentTotal, goodsKey, discount,
        beforeText: beforeValue.textContent.trim(), savingText,
        quoteKey: goodsKey + '|' + before + '|' + discount + '|' + final
      };
    }

    function ensureLayer(currentTotal) {
      if (total === currentTotal && overlay && overlay.isConnected && badge && badge.isConnected) return;
      reset();
      if (overlay) overlay.remove();
      if (badge) badge.remove();
      total = currentTotal;
      overlay = document.createElement('span');
      overlay.className = 'qa-discount-reveal__visual';
      overlay.setAttribute('data-qa-discount-reveal-owned', '');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.hidden = true;
      visualLabel = document.createElement('span');
      visualLabel.className = 'qa-discount-reveal__label';
      visualValue = document.createElement('strong');
      visualValue.className = 'qa-discount-reveal__value';
      overlay.append(visualLabel, visualValue);
      badge = document.createElement('span');
      badge.className = 'qa-discount-reveal__saving';
      badge.setAttribute('data-qa-discount-reveal-owned', '');
      badge.setAttribute('aria-hidden', 'true');
      badge.hidden = true;
      total.append(overlay, badge);
    }

    function phase(name, label, value) {
      if (visualLabel.textContent !== label) visualLabel.textContent = label;
      if (visualValue.textContent !== value) visualValue.textContent = value;
      overlay.hidden = false;
      badge.hidden = true;
      total.setAttribute('data-qa-discount-reveal-phase', name);
    }

    function showFinal(snapshot, highlighted) {
      overlay.hidden = true;
      const copy = 'Du sparer ' + snapshot.savingText;
      if (badge.textContent !== copy) badge.textContent = copy;
      badge.hidden = false;
      total.setAttribute('data-qa-discount-reveal-phase', highlighted ? 'final' : 'settled');
    }

    function settle(snapshot) {
      showFinal(snapshot, false);
    }

    function later(delay, token, quoteKey, action) {
      const timer = window.setTimeout(() => {
        timers.delete(timer);
        try {
          if (token !== generation || disabled) return;
          const current = read();
          if (!current || current.busy || current.quoteKey !== quoteKey) { reset(); return; }
          action(current);
        } catch (_) { failOpen(); }
      }, delay);
      timers.add(timer);
    }

    function refresh() {
      if (disabled || !cssReady) return;
      const snapshot = read();
      if (!snapshot) { reset(); return; }
      ensureLayer(snapshot.total);
      if (snapshot.busy) {
        reset();
        phase('calculating', 'Beregner totalpris og rabatt …', '');
        return;
      }
      if (snapshot.discount === 0n) {
        reset();
        lastSettledGoods = snapshot.goodsKey;
        return;
      }
      if (activeQuoteKey === snapshot.quoteKey) return;
      reset();
      activeQuoteKey = snapshot.quoteKey;
      const reveal = lastSettledGoods !== snapshot.goodsKey;
      lastSettledGoods = snapshot.goodsKey;
      if (!reveal || reducedMotion.matches) { settle(snapshot); return; }
      const token = generation;
      phase('before', 'Før rabatt', snapshot.beforeText);
      later(650, token, snapshot.quoteKey, current => phase('saving', 'Du sparer', current.savingText));
      later(1150, token, snapshot.quoteKey, current => showFinal(current, true));
      later(1600, token, snapshot.quoteKey, settle);
    }

    function schedule() {
      if (disabled || queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        try { refresh(); } catch (_) { failOpen(); }
      });
    }

    const observer = new MutationObserver(records => { if (records.some(relevantMutation)) schedule(); });
    observer.observe(scope, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['hidden', 'aria-busy', 'data-aa-amount', 'data-aa-line-key',
        'data-aa-last-numeric-value', 'data-aa-line-dirty', 'data-aa-line-saving', 'inert']
    });
    const hostObserver = new MutationObserver(schedule);
    hostObserver.observe(root, { attributes: true,
      attributeFilter: ['hidden', 'data-aa-open', 'data-aa-state', 'data-aa-line-intent',
        'data-aa-offer-form-mode', 'data-aa-cart-transaction', 'data-aa-vendor-modal', 'data-aa-pending-cart-phase'] });
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = stylesheet;
    link.setAttribute('data-qa-discount-reveal-owned', '');
    link.addEventListener('load', () => { cssReady = true; schedule(); }, { once: true });
    link.addEventListener('error', failOpen, { once: true });
    scope.append(link);
    const motionChanged = () => {
      if (reducedMotion.matches && activeQuoteKey) {
        try {
          const current = read();
          reset();
          if (current && !current.busy && current.discount > 0n) {
            activeQuoteKey = current.quoteKey;
            settle(current);
          }
        } catch (_) { failOpen(); }
      }
    };
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', motionChanged);
    return schedule;
  }

  function discover() {
    document.querySelectorAll('[data-msno-aa-fk7-v2]').forEach(root => {
      if (controllers.has(root)) return;
      const scope = root.shadowRoot || root;
      if (!scope.querySelector('[data-aa-total]')) return;
      try { controllers.set(root, mount(root, scope)); } catch (_) { /* Native UI remains intact. */ }
    });
  }

  const discovery = new MutationObserver(discover);
  discovery.observe(document.documentElement, { subtree: true, childList: true, attributes: true,
    attributeFilter: ['data-aa-open', 'data-aa-state'] });
  discover();
}());
